import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useScrapeBatchStatus } from '@/hooks/useScrapeBatchStatus';
import { RefreshCw, CheckCircle } from 'lucide-react';

const CrawlProgressBar = ({ clientId, className = '', onComplete }) => {
  const { hasBatch, batch, summary } = useScrapeBatchStatus(clientId, onComplete);

  if (!hasBatch || !batch) {
    return null;
  }

  if (!batch.is_active) {
    return null;
  }

  const completed = summary?.completed || 0;
  const total = summary?.total || 0;
  const percentage = total > 0 ? Math.min(100, Math.round((completed / total) * 100)) : 0;

  return (
    <Card className={`border-blue-200 bg-blue-50/50 ${className}`}>
      <CardContent className="pt-6">
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-blue-700">
              <RefreshCw className="w-4 h-4 animate-spin" />
              <span className="font-semibold">Crawling Site...</span>
            </div>
            <span className="text-sm font-medium text-blue-600">
              {completed} / {total} pages ({percentage}%)
            </span>
          </div>

          <div className="w-full bg-blue-100 rounded-full h-2.5 overflow-hidden">
            <div
              className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-out"
              style={{ width: `${percentage}%` }}
            />
          </div>

          {batch.current_url && (
            <p className="text-xs text-blue-600 truncate">
              Current: {batch.current_url}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default CrawlProgressBar;
